import React from 'react';
import { FasterSchedulingContextProvider } from "./contexts/store";
import FasterScheduling from "./FasterScheduling";
import "./FasterSchedulingStyles.css";

const FasterSchedulingContainer = ({
  availabilityStore,
  sendToCalendarService,
  eplModel,
  handleClose,
  growlStore,
  // clearIndexedDB,
  onDeleteTimeslot,
  project,
  multipleExperts,
  showAddExpert,
  multiAction // renderPhoneNumbers,
  // projectStore

}) => {
  // console.log({ availabilityStore, growlStore, project })
  return /*#__PURE__*/React.createElement(FasterSchedulingContextProvider, null, /*#__PURE__*/React.createElement(FasterScheduling, {
    availabilityStore: availabilityStore,
    sendToCalendarService: sendToCalendarService,
    eplModel: eplModel,
    handleClose: handleClose // projectStore={projectStore}
    ,
    growlStore: growlStore // clearIndexedDB={clearIndexedDB}
    ,
    onDeleteTimeslot: onDeleteTimeslot,
    project: project,
    multipleExperts: multipleExperts,
    showAddExpert: showAddExpert,
    multiAction: multiAction // renderPhoneNumbers={renderPhoneNumbers}

  }));
};

export default FasterSchedulingContainer;